import React, { useState } from 'react';
import { toast } from 'react-toastify';
import Spinner from './Spinner';
import { issueStock } from '../utils/api'; // This function needs to be created in your api.ts

const StockIssue = () => {
    const [productId, setProductId] = useState<string>('3618');
    const [quantity, setQuantity] = useState<number>(1);
    const [loading, setLoading] = useState<boolean>(false);

    const handleissueStock = async () => {
        if (!productId.trim() || !quantity) {
            toast.error("Product ID and quantity are required.");
            return;
        }

        const productIdNum = parseInt(productId, 10);
        if (isNaN(productIdNum)) {
            toast.error("Invalid Product ID.");
            return;
        }

        if (quantity <= 0) {
            toast.error("Quantity must be a positive number.");
            return;
        }

        setLoading(true);
        try {
            const response = await issueStock(productIdNum, quantity);
            toast.success(response.message || `Successfully issued ${quantity} of product ID ${productIdNum}.`);
        } catch (err: any) {
            toast.error(err.message || "Failed to issue stock.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container mx-auto p-4 max-w-lg">
            {loading && <Spinner />}
            <h1 className="text-2xl font-bold mb-6">Issue Stock</h1>
            <div className="bg-white p-6 rounded-lg shadow-md">
                <div className="mb-4">
                    <label htmlFor="productId" className="block text-sm font-medium text-gray-700 mb-1">Product ID</label>
                    <input type="text" id="productId" value={productId} onChange={(e) => setProductId(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500" placeholder="Enter Product ID" />
                </div>
                <div className="mb-6">
                    <label htmlFor="quantity" className="block text-sm font-medium text-gray-700 mb-1">Quantity to Issue</label>
                    <input type="number" id="quantity" value={quantity} onChange={(e) => setQuantity(parseInt(e.target.value, 10) || 0)} className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500" min="1" />
                </div>
                <button onClick={handleissueStock} disabled={loading} className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition duration-150 disabled:opacity-50">{loading ? 'Processing...' : 'Issue Stock'}</button>
            </div>
        </div>
    );
};

export default StockIssue;

